import React, { useState } from "react";
import "./ExamplePage.css"; // Ensure this CSS file is linked

const ExamplePage = () => {
  const [fontSize, setFontSize] = useState("16px");
  const [fontStyle, setFontStyle] = useState("Arial");
  const [layout, setLayout] = useState("single"); // single or double column
  const [selected, setSelected] = useState("btnradio1");


  const questions = [
    {
      question: "What is the capital of France?",
      options: ["1. Berlin", "2. Madrid", "3. Paris", "4. Rome"],
      answer: "3. Paris",
    },
    {
      question: "Which planet is known as the 'Red Planet'?",
      options: ["1. Venus", "2. Mars", "3. Jupiter", "4. Saturn"],
      answer: "2. Mars",
    },
    {
      question: "Who invented the telephone?",
      options: [
        "1. Thomas Edison",
        "2. Nikola Tesla",
        "3. Alexander Graham Bell",
        "4. Albert Einstein",
      ],
      answer: "3. Alexander Graham Bell",
    },
    {
      question: "What is the largest ocean in the world?",
      options: [
        "1. Atlantic Ocean",
        "2. Indian Ocean",
        "3. Pacific Ocean",
        "4. Arctic Ocean",
      ],
      answer: "3. Pacific Ocean",
    },
    {
      question: "Which is the tallest mountain in the world?",
      options: [
        "1. K2",
        "2. Mount Kilimanjaro",
        "3. Mount Everest",
        "4. Mount Fuji",
      ],
      answer: "3. Mount Everest",
    },
    {
      question: "Which country is known as the 'Land of the Rising Sun'?",
      options: ["1. China", "2. Japan", "3. South Korea", "4. Thailand"],
      answer: "2. Japan",
    },
    {
      question: "What is the boiling point of water?",
      options: ["1. 90°C", "2. 100°C", "3. 120°C", "4. 80°C"],
      answer: "2. 100°C",
    },
    {
      question: "What is the chemical symbol for gold?",
      options: ["1. Ag", "2. Au", "3. Pb", "4. Hg"],
      answer: "2. Au",
    },
    {
      question: "Who was the first President of the United States?",
      options: [
        "1. Thomas Jefferson",
        "2. Abraham Lincoln",
        "3. George Washington",
        "4. John Adams",
      ],
      answer: "3. George Washington",
    },
    {
      question: "Which is the longest river in the world?",
      options: [
        "1. Amazon River",
        "2. Nile River",
        "3. Yangtze River",
        "4. Mississippi River",
      ],
      answer: "2. Nile River",
    },
    {
      question: "In which year did World War II end?",
      options: ["1. 1940", "2. 1945", "3. 1950", "4. 1939"],
      answer: "2. 1945",
    },
    {
      question: "Which is the hardest natural substance on Earth?",
      options: ["1. Gold", "2. Diamond", "3. Iron", "4. Quartz"],
      answer: "2. Diamond",
    },
    {
      question: "What is the square root of 64?",
      options: ["1. 6", "2. 7", "3. 8", "4. 9"],
      answer: "3. 8",
    },
    {
      question: "Which element is the most abundant in the Earth's crust?",
      options: ["1. Oxygen", "2. Silicon", "3. Iron", "4. Calcium"],
      answer: "1. Oxygen",
    },
    {
      question: "Which country is the largest by area?",
      options: ["1. Canada", "2. United States", "3. Russia", "4. China"],
      answer: "3. Russia",
    },
    {
      question: "Who wrote the novel '1984'?",
      options: [
        "1. Aldous Huxley",
        "2. George Orwell",
        "3. J.K. Rowling",
        "4. Ernest Hemingway",
      ],
      answer: "2. George Orwell",
    },
    {
      question: "What is the most widely spoken language in the world?",
      options: ["1. Spanish", "2. Mandarin Chinese", "3. English", "4. Hindi"],
      answer: "2. Mandarin Chinese",
    },
    {
      question: "Which animal is known as the 'King of the Jungle'?",
      options: ["1. Tiger", "2. Elephant", "3. Lion", "4. Leopard"],
      answer: "3. Lion",
    },
    {
      question: "What is the capital of Australia?",
      options: ["1. Sydney", "2. Melbourne", "3. Brisbane", "4. Canberra"],
      answer: "4. Canberra",
    },
    {
      question: "How many continents are there?",
      options: ["1. 5", "2. 6", "3. 7", "4. 8"],
      answer: "3. 7",
    },
    {
      question: "What is the largest planet in our solar system?",
      options: ["1. Earth", "2. Mars", "3. Jupiter", "4. Saturn"],
      answer: "3. Jupiter",
    },
  ];

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="page-container">
      {/* Left section - Settings */}
      <div className="settings-section " style={{ backgroundColor: "#FBEFDA" }}>
        {/* //#FBEFDA */}
        <h2>Settings</h2>

        <div
          className="btn-group"
          
          role="group"
          aria-label="Basic radio toggle button group"
        >
          <input
            type="radio"
            className="btn-check "
           
            name="btnradio"
            id="btnradio1"
            autoComplete="off"
            checked={selected === "btnradio1"}
            onChange={() => setSelected("btnradio1")}
          />
          <label className="btn btn-outline-secondary " htmlFor="btnradio1">
            Question Paper
          </label>

          <input
            type="radio"
            className="btn-check"
            name="btnradio"
            id="btnradio2"
            autoComplete="off"
            checked={selected === "btnradio2"}
            onChange={() => setSelected("btnradio2")}
          />
          <label className="btn btn-outline-secondary" htmlFor="btnradio2">
            Answer Key
          </label>
        </div>

        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <div className="setting-item">
            <label>Font Style:</label>
            <br></br>
            <div className="flex-align gap-8 flex-wrap">
              <div className="flex-align gap-8 flex-wrap">
                <div class="position-relative text-gray-500 flex-align gap-4 text-13">
                  <span class="text-inherit"> </span>
                  <div class="flex-align text-gray-500 text-13 border border-gray-100 rounded-4  focus-border-main-600 bg-white">
                    <select
                      class="form-control   text-16 text-balck text-inherit rounded-4 text-center"
                      onChange={(e) => setFontStyle(e.target.value)}
                      value={fontStyle}
                    >
                      <option value="Arial">Arial</option>
                      <option value="Times New Roman">Times New Roman</option>
                      <option value="Verdana">Verdana</option>
                      <option value="Courier New">Courier New</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="setting-item">
            <label></label>
            <div className="flex-align gap-8 flex-wrap">
              <div class="position-relative text-gray-500 flex-align gap-4 text-13">
                <span class="text-inherit"> </span>
                <div class="flex-align text-gray-500 text-13 border border-gray-100 rounded-4  focus-border-main-600 bg-white">
                  <select
                    class="form-control   text-16 text-balck text-inherit rounded-4 text-center"
                    onChange={(e) => setFontSize(e.target.value)}
                    value={fontSize}
                  >
                    <option value="16px">16px </option>
                    <option value="18px">18px</option>
                    <option value="20px">20px</option>
                    <option value="22px">22px</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="setting-item">
          <label>Layout</label>
          <select onChange={(e) => setLayout(e.target.value)} value={layout}>
            <option value="single">single</option>
            <option value="double">double</option>
          </select>
        </div>
        <button onClick={handlePrint} className="print-button">
          Print
        </button>
      </div>

      {/* Right section - Question Paper */}
      <div className="question-paper">
        <h3
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          SARVAJNA AND JUSTICE SHIVARAJ PATIL COLLEGE
        </h3>
        <h5
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          BEHIND SAIMANDIR HIGHCOURT RINGROAD GULBARGA{" "}
        </h5>
        <h5
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Kalaburgi, Karnataka 585102
        </h5>
        <hr></hr>

        <div className={`question-paper-content ${layout}`}>
          {questions.map((item, index) => (
            <div
              key={index}
              className="question-item"
              style={{ fontSize, fontFamily: fontStyle }}
            >
              <p>
                {index + 1}. {item.question}
              </p>
              <ul style={{ margin: "5px" }}>
                {item.options.map((option, idx) => (
                  <li key={idx}>{option}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExamplePage;
